export class AnyClass {
}
//# sourceMappingURL=concrete.js.map